import { Component, Input, OnInit } from '@angular/core';
import { AppSettingsConfig } from 'src/app/config/app-settings.config';

@Component({
    selector: 'vl-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss']
})
export class IconComponent implements OnInit {
    @Input() widthProp = 24;
    @Input() heightProp = 24;
    @Input() name: string;
    @Input() color: 'primary' | 'white' | 'black' | 'grey' | any = '#000000';

    public absUrl = AppSettingsConfig.pathToiConMoon;

    constructor() {
    }

    ngOnInit() {
        switch (this.color) {
            case 'primary':
                this.color = '#6B32C8';
                break;
            case 'white':
                break;
            case 'grey':
                this.color = '#A7A7AE';
                break;
            case 'light-grey':
                this.color = '#EDEEF3';
                break;
            case 'black':
                this.color = '#130F26'
        }
    }
}
